<template>
  <div v-if="project_info" class="project_profile">
    <div class="project_profile__left" >
      <div class="line row">
        <div class="col-md-3 col-sm-3">
          <router-link :to="'/client/' + project_info.client_id" class="link">
            <fg-input
                v-model="project_info.client"
                type="text"
                :label="translate('project.client')"
                :placeholder="translate('project.client')"
                :readonly="true"
            />
          </router-link>
        </div>

        <div class="col-md-3 col-sm-3">
          <fg-input
              v-model="project_info.name"
              type="text"
              :label="translate('project.name')"
              :placeholder="translate('project.name')"
          />
        </div>

        <div class="col-md-3 col-sm-3">
          <label> {{ translate('project.status') }} </label>
          <tree-select
              v-model="project_info.status"
              :options="status_list"
              :placeholder="translate('project.status')"
              :clearable="false"
              :searchable="false"
          />
        </div>
        <div class="col-md-3 col-sm-3">
          <label> {{ translate('project.priority') }} </label>
          <tree-select
              v-model="project_info.priority"
              :options="priority_list"
              :placeholder="translate('project.priority')"
              :clearable="false"
              :searchable="false"
          />
        </div>
      </div>

      <div class="line row">
        <div class="col-md-12 col-sm-12 text_wrap">
          <div class="form-group">
            <label>{{ translate('project.description') }}</label>
            <textarea rows="6" class="input_text" name="description" v-model="project_info.description"/>
          </div>
        </div>
      </div>

      <div class="line text-center">
        <span
            v-if="has_changes"
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="edit_projects"
        >
          {{ translate('btn.edit') }}
        </span>
      </div>
    </div>

    <div class="project_profile__right">
      <Summary
        type="project"
        :info="project_info"
        :view_history="false"
      />
    </div>
  </div>

</template>
<script>

import Summary from "components/UIComponents/Summary/Summary.vue";

export default {
  components: {
    Summary
  },

  props: {
    project:{
      type: Object,
      required: true
    }
  },

  data () {
    return {
      project_info: {}
    }
  },

  created() {
    this.project_info = JSON.parse(JSON.stringify(this.project))
  },

  activated() {
    this.project_info = JSON.parse(JSON.stringify(this.project))
  },

  computed: {
    status_list(){
      return this.$store.getters.getProjectInfo.statuses.map((entry) => {
        return {id: entry.id, label: entry.title}
      })
    },

    priority_list(){
      return this.$store.getters.getProjectInfo.prioritys.map((entry) => {
        return {id: entry.id, label: entry.title}
      })
    },

    has_changes(){
      // поля из выпадающих списков
      let main_info = Object.assign({}, this.project_info)
      let project_info = Object.assign({}, this.project)

      return JSON.stringify(main_info) !== JSON.stringify(project_info)
    }
  },

  watch : {

  },

  methods: {
    edit_projects(){
      this.$http.v1.updateProject(this.project_info.id, this.project_info, (response) => {
        this.global_notify('info', this.translate('project.saved_success'))
        this.project_info = response.data.project
        this.$emit('update')
      })
    }
  }
}

</script>

<style lang='scss' scoped>
.project_profile {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
  }

  &__right {
    width: 30%;
    height: 100%;
  }
}

</style>
